import React from 'react';
import PropTypes from 'prop-types';
import { throttle } from 'lodash';

export default class StickyBottomHelper extends React.PureComponent {
    static propTypes = {
        children: PropTypes.node.isRequired,
        scrollingContainerId: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            isStuck: false
        }

        this.container = undefined;
        this.wrapperHeight = undefined;
        this.windowHeight = undefined;
        this.initialBottom = undefined;
        this.hasPageSettled = false;

        this.throttledHandleResize = throttle(this.handleResize, 250);
    }

    componentDidMount() {
        this.wrapperHeight = this.getStickyHeight();
        this.wrapper.style.height = `${this.wrapperHeight}px`;
        this.windowHeight = window.innerHeight;
        this.container = document.getElementById(this.props.scrollingContainerId);

        window.addEventListener('resize', this.throttledHandleResize);
        document.addEventListener('scroll', this.handleScroll);
        this.container.addEventListener('scroll', this.handleScroll);

        this.setInitialSticky();
    }

    componentDidUpdate() {
        if (!this.hasPageSettled) {
            this.setInitialSticky();
        }
    }

    componentWillUnmount() {
        this.container.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.throttledHandleResize);
    }

    getStickyHeight() {
        // Sometimes because of CSS media queries or timing, the sticky height
        // can comeback as 0. We'll use the first child's height as a fallback
        // to prevent jank
        const stickyHeight = this.sticky.offsetHeight;
        const childHeight = this.sticky.firstChild.offsetHeight;
        return stickyHeight || childHeight;
    }

    setWrapperRef = (node) => this.wrapper = node;

    setStickyRef = (node) => this.sticky = node;

    setSticky = () => {
        const bottom = this.wrapper.getBoundingClientRect().bottom;

        this.setState({
            isStuck: bottom > this.windowHeight
        });
    }

    setInitialSticky = () => {
        // Because the bottom sticky thing is at the bottom of the page, it can
        // take a while before all the other stuff above to finish rendering
        // out. So we're going to repeatedly check the bottom value until it
        // settles out. Then we can set sticky for the first time.
        const bottom = this.wrapper.getBoundingClientRect().bottom;

        if (bottom !== this.initialBottom) {
            setTimeout(() => {
                this.initialBottom = bottom;
                this.forceUpdate();
            }, 450);
        }
        else {
            this.hasPageSettled = true;
            this.setSticky();
        }
    }

    handleResize = () => {
        this.windowHeight = window.innerHeight;
        const updatedHeight = this.getStickyHeight();

        if (updatedHeight !== this.wrapperHeight) {
            this.wrapperHeight = updatedHeight;
            this.wrapper.style.height = `${this.wrapperHeight}px`;
        }

        this.setSticky();
    }

    handleScroll = () => {
        this.setSticky();
    };

    render() {
        const style = this.state.isStuck ? 'rec-sticky-bottom sticky' : 'rec-sticky-bottom';

        return (
            <div ref={this.setWrapperRef}>
                <div ref={this.setStickyRef} className={style}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
